import { Action } from "../../../actions/actions";
import { GamesActionTypes } from "../actions/actionTypes";

export function creatingBundle(
    state: any = {
        values: {
            name: "",
            games: [],
            alias: []
        },
        isValid: false
    },
    action: Action
) {
    const values =
        state && action.payload
            ? { ...state.values, ...action.payload.values }
            : action.payload
            ? action.payload.values
            : null;

    const isValid = state && action.payload ? action.payload.isValid : false;

    switch (action.type) {
        case GamesActionTypes.UPDATE_CREATING_BUNDLE:
            return {
                values,
                isValid: isValid
            };

        case GamesActionTypes.CREATE_BUNDLE_SUCCESS:
        case GamesActionTypes.EDIT_BUNDLE_SUCCESS:
            return null;

        case GamesActionTypes.CREATE_BUNDLE_RESET:
            return null;

        default:
            return state;
    }
}
